<template>
    <PageContent>
        <PageTitle>Order Data for Upload</PageTitle>
        <div class="container">
            <div class="row">
                <div class=" col-xl-6 offset-xl-3 border p-3">
                    <div class="alert alert-info">Any orders that have not been shipped will not be included in this report.</div>
                    <form @submit.prevent.stop="">
                        <fieldset :disabled="busy">
                            <div class="form-group">
                                <label for="">Order Date</label>
                                <div class="row mt-1">
                                    <div class="col-lg-6">
                                        <label>From</label>
                                        <input type="text" name="txtsdate" v-model="txtsdate" class="form-control datepicker" required readonly>
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="">To</label>
                                        <input type="text" name="txtedate" v-model="txtedate" class="form-control datepicker" required readonly>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Data Type</label>
                                <select name="reportType" id="reportType`    jIN76" v-model="reportType" class="form-select">
                                    <option value="cantalope">Cantalope</option>
                                    <option value="lightspeed">Lightspeed</option>
                                </select>
                            </div> 
                            <div class="mt-3">
                               <div class="text-center mt-3">
                                    <!-- <a :href="`${$store.state.url}/api/pdfs/${reportType}Data-CSV.php?&custno=${$root.getCustomerNumber()}&startdate=${txtsdate}&enddate=${txtedate}&token=${$store.state.localStorage.token}`" target="_blank" class="btn btn-primary">Download File</a> -->
                                    <a :href="`https://orders.kffoods.com/api/pdfs/${reportType}Data-CSV.php?&custno=${$root.getCustomerNumber()}&startdate=${txtsdate}&enddate=${txtedate}&token=${$store.state.localStorage.token}`" target="_blank" class="btn btn-primary">Download File</a>
                                    <!-- <button @click.preven.stop="checkOrderStatuses" class="btn btn-primary">Download File</button> -->
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </PageContent>
  </template>
  <script>
  import axios from 'axios';
  import PageContent from '@/components/PageContent.vue';
  import NotReady from '@/components/NotReady.vue';
  import PageTitle from '@/components/PageTitle.vue';
  export default {
    name: 'OrderSummaryDataFile',
    components: {PageContent, PageTitle,  NotReady},
    data(){
        return {
            busy:false,
            ready:false,
            disabled:false,
            LOCFILTER:'',
            retry:1,
            reportType:'cantalope',
            txtsdate:'',
            txtedate:'',
            shipTo:localStorage.getItem('shipTo')!=null?localStorage.getItem('shipTo'):'',
            fileUrl:'',
            UPCDashes:'false',
        }
    },
    watch:{
        filetype(newVal){
            if(newVal=='PDF'){
                this.sort = '';
            }
            else this.sort = 'ITEM';
        }
    },
    async mounted(){
        this.ready = true;
        this.busy = true;
        await Sleep(10);
        const customer = (this.$root.customer())
        // let res = await axios.get(`${this.$store.state.api}/check_order_status_date?&lccustno=${this.$root.getCustomerNumber()}`);
        // let res = await axios.get(`https://orders.kffoods.com/api/check_order_status_date?&lccustno=${this.$root.getCustomerNumber()}`);
        $( ".datepicker" ).datepicker({
            // maxDate:moment(res['make date'].date).format('MM/DD/YYYY'),
            onSelect:async (date,target)=>{
                this[target.input.attr('name')] = date;
            }
        });
        // this.txtsdate = moment(res['make date'].date).format('MM/DD/YYYY');
        // this.txtedate = moment(res['make date'].date).format('MM/DD/YYYY');
        this.txtsdate = moment().format('MM/DD/YYYY');
        this.txtedate = moment().format('MM/DD/YYYY');
        this.busy = false;
        
    },
    methods:{
       checkOrderStatuses:function(){
        //make date 
            let start = (moment(this.txtsdate, "MM/DD/YYYY"));
            let end = (moment(this.txtedate, "MM/DD/YYYY"));
            let current = start.clone(); 
            let dates = [];

        }
    },
  }
  </script>
  <style lang="scss" scoped>
    
  </style>
